<template>
  <div class="pagination">
    <span>{{$t('news.total') + " " + total + " "+$t('news.item') }}</span>
    <ul class="pagination pagination-lg justify-content-center m-2" :class="{'disabled':curPage === 1}">
      <li class="page-item" :class="{'disabled1':curPage === 1}">
        <a class="page-link" @click="changeCurrentPage(curPage - 1)">&lt;</a>
      </li>
    </ul>
    <ul class="pagination pagination-lg justify-content-center m-2" v-for="(item, index) in pageTotalNum" :key="index">

      <li class="page-item"><a class="page-link" @click="changeCurrentPage(item)" :class="{ active: curPage === index + 1 }">{{item}}</a></li>
    </ul>
    <ul class="pagination pagination-lg justify-content-center m-2" :class="{'disabled':curPage === pageTotalNum}">

      <li class="page-item" :class="{'disabled1':curPage === pageTotalNum}" >
        <a class="page-link" @click="changeCurrentPage(curPage + 1)">&gt;</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    // 商品总数量
    total: {
      type: Number,
      default: 0,
    },
    // 当前页
    curPage: {
      type: Number,
      default: 1,
    },
    // 每页大小
    pageSize: {
      type: Number,
      default: 9,
    },
  },
  methods: {
    changeCurrentPage(curPage) {
      if (this.curPage === curPage) {
        return
      }
      this.$emit("current-page", curPage);
    },
  },
  computed: {
    // 总页码数
    pageTotalNum() {
      return Math.ceil(this.total / this.pageSize);
    },
    // 当前页码的前2位
    // start() {
    //   // 当前页码小于3,左右不对称,start直接为1
    //   if (this.curPage < 3) {
    //     // console.log('11',this.curPage);
    //     return 1;
    //   } else {
    //     // console.log('首个',this.curPage);
    //     return this.curPage - 2;
    //   }
    // },
    // // 当前页码的后2位
    // end() {
    //   // 当前页码不能大于总页码-2
    //   if (this.curPage > this.pageTotalNum - 2) {
    //     // console.log('222',this.pageTotalNum);
    //     return this.pageTotalNum;
    //   }
    //   else{
    //     return this.curPage + 2;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  .disabled{
    cursor: not-allowed;
      .disabled1{
        pointer-events: none;
      }
  }
  span {
    color: rgba(34, 34, 34, 1);
    font-size: 0.75rem;
    height: 1.5rem;
    line-height: 1.5rem;
  }
  .active {
    // background-color: #409eff;
    background-color: rgba(20, 87, 223, 1);
    
    font-weight: bold;
    color: #fff;
    cursor: unset;
  }
}
</style>